import { render, staticRenderFns } from "./leadsPerForm.vue?vue&type=template&id=0fff2c63"
import script from "./leadsPerForm.vue?vue&type=script&lang=js"
export * from "./leadsPerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports